/**
 * Eon API
 * The Eon.io REST API
 *
 * AUTOGENERATED: Do not edit the class manually.
 * Instead edit the .mustache file and run `node --run gen-openapi`
 */

import { BackupPolicy } from '../models/BackupPolicy';

export class UpdateBackupPolicyResponse {
  'backupPolicy': BackupPolicy;

  static readonly discriminator: string | undefined = undefined;

  static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
    {
      "name": "backupPolicy",
      "baseName": "backupPolicy",
      "type": "BackupPolicy",
      "format": ""
    }  ];

  static getAttributeTypeMap() {
    return UpdateBackupPolicyResponse.attributeTypeMap;
  }

  public constructor() {
  }
}

